// Reads a newline-delimited JSON response, handing over each line's value as
// soon as the line is complete. A chunk can end anywhere, even inside a
// multi-byte character, so bytes are decoded as a stream and only whole lines
// are parsed
export const readJsonLines = async <T>(
  body: ReadableStream<Uint8Array>,
  onValue: (value: T) => void
) => {
  const reader = body.getReader()
  const decoder = new TextDecoder()
  let buffered = ""

  while (true) {
    const { done, value } = await reader.read()
    buffered += decoder.decode(value, { stream: !done })
    const lines = buffered.split("\n")
    buffered = done ? "" : (lines.pop() as string)
    for (const line of lines) if (line.trim()) onValue(JSON.parse(line))
    if (done) return
  }
}
